import React from "react";

function Header() {
  return (
    <header>
      <h1>        
        My Notepad
      </h1>
    </header>
  );
}

export default Header;
